import React, { useState, useEffect, cloneElement } from 'react';

const FieldWithDebounce = ({handleDebouncedAction, onChange, children}) => {
    const [debounceTimeout, setDebounceTimeout] = useState(null);
  
    const handleInputChange = (value) => {
      onChange(value);
  
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      const newTimeout = setTimeout(() => {
        handleDebouncedAction(value);
      }, 1500); // 1.5 seconds delay
  
      setDebounceTimeout(newTimeout);
    }

    return (
        cloneElement(children, {onChange: handleInputChange})
    )

}

export default FieldWithDebounce